"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minimumLength = void 0;
const lang_1 = __importDefault(require("../../../lang"));
exports.minimumLength = 8;
function zipCode() {
    return this
        .matches(/^\d{5}(-\d{4})?$/, (0, lang_1.default)().validation.zipCode);
}
exports.default = zipCode;
